import React from "react";
import { styled } from "@mui/system";
import Medal from "./Medal";
import { capitalize } from "lodash";
import QRCodeBadge from "../extra/QRCodeBadge";

const Wrapper = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "24px",
}));

const MedalWrapper = styled("div")(() => ({
  width: "100px",
  height: "100px",
  flexShrink: 0,
}));

const HeaderAndText = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  flex: "1 0 0",
}));

const Header = styled("div")(({ theme }) => ({
  alignSelf: "stretch",
  color: "#002035",
  fontFamily: "Roobert",
  fontSize: "23px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "28px",
  letterSpacing: " -0.46px",

  [theme.breakpoints.down(720)]: {
    fontSize: "16px",
    lineHeight: "19px",
    letterSpacing: " -0.32px",
  },
}));

const Text = styled("div")(({ theme }) => ({
  color: "#002035",
  fontFamily: "Söhne",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "19px",

  [theme.breakpoints.down(720)]: {
    fontSize: "14px",
    lineHeight: "17px",
  },
}));

const QRWapper = styled("div")(({ theme }) => ({
  [theme.breakpoints.down(720)]: {
    display: "none",
  },
}));

interface ProfileBannerProps {
  header: string;
  customerID: string;
  tier: "bronze" | "silver" | "gold" | "black";
}

/**
 * A profile banner component to display user profile information.
 * @param {string} props.header - The header text for the profile banner.
 * @param {string} props.customerID - The customer ID for the profile.
 * @param {("bronze" | "silver" | "gold" | "black")} props.tier - The tier of the user profile.
 */
const ProfileBanner = (props: ProfileBannerProps) => {
  const { header, customerID, tier } = props;

  return (
    <Wrapper>
      {/* Medal */}
      <MedalWrapper>
        <Medal tier={tier} />
      </MedalWrapper>

      {/* Header and text */}
      <HeaderAndText>
        <Header>{header}</Header>
        <Text>{customerID}</Text>
        {<Text>{capitalize(tier)}</Text>}
      </HeaderAndText>

      {/* QR */}
      <QRWapper>
        <QRCodeBadge tier={tier} backgroundSize="130px" qrSize={110} />
      </QRWapper>
    </Wrapper>
  );
};

export default ProfileBanner;
